// Error Messages
export const ASSET_ERROR_MSG = "Sorry, something went wrong"
export const SERVER_ERROR_MSG = "Sorry, something went wrong"
export const GENERIC_ERROR_TITLE = "Error"
export const GENERIC_MESSAGE_TITLE = "Important Note"

// Asset Messages
export const ASSET_NOT_FOUND_MSG = "Some items have been removed. You can always UNDO the last change"
export const OLD_ASSET_MSG = "We have released a new version. All old designs have been retired, as such. Design something new!"

// Scene Messages
export const SCENE_INIT_ERROR_MSG = "Failed to initialize 3D scene"
export const SCENE_RENDER_ERROR_MSG = "Failed to render 3D scene"
export const SCENE_LOADING_ERROR_MSG = "Failed to load scene assets"

// User Interface Messages
export const LOADING_MSG = "Loading..."
export const INITIALIZING_MSG = "Initializing..."
export const PROCESSING_MSG = "Processing..."

// Success Messages
export const SUCCESS_MSG = "Operation completed successfully"
export const SAVE_SUCCESS_MSG = "Data saved successfully"

// Warning Messages
export const WARNING_MSG = "Warning"
export const CONFIRMATION_MSG = "Are you sure?"

// Device Messages
export const IOS_COLOR_MESSAGE = "Beta does not support this device currently. Please use desktop in the meanwhile. Check back soon for updates!"
export const MOBILE_UNSUPPORTED_MSG = "This feature is not supported on mobile devices"

// Network Messages
export const NETWORK_ERROR_MSG = "Network connection error"
export const TIMEOUT_ERROR_MSG = "Request timed out"
export const UNAUTHORIZED_MSG = "Unauthorized access"
export const FORBIDDEN_MSG = "Access forbidden"
export const NOT_FOUND_MSG = "Resource not found"
export const INTERNAL_SERVER_ERROR_MSG = "Internal server error"
